<template>
	<Row>
		<Col :span="24" :offset="0" :sm="smRef">
			<div :class="classes">
				<InfoCircleOutlined class="info-icon" />
				<slot />
			</div>
		</Col>
	</Row>
</template>

<script>
import { toRef, computed } from 'vue';
import { Row, Col } from 'ant-design-vue';
import { InfoCircleOutlined } from '@ant-design/icons-vue';

export default {
	components: {
		Row, Col, InfoCircleOutlined,
	},
	props: {
		formMode: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const formModeRef = toRef(props, 'formMode');
		const smRef = computed(() => formModeRef.value ? { span: 16, offset: 8 } : { span: 24, offset: 0 });
		const classes = computed(() => formModeRef.value ? ['info-alert-wrapper', 'info-alert-wrapper--form-mode'] : ['info-alert-wrapper']);
		return {
			smRef,
			classes,
		};
	},
};
</script>

<style scoped>
.info-alert-wrapper {
	display: inline-block;
	color: #1890ff;
	background: #e6f7ff;
	box-sizing: border-box;
	margin-block-end: 24px;
	padding-inline: 7px;
	padding-block: 3px;
	font-size: 12px;
	line-height: 20px;
	border: 1px solid #91d5ff;
	border-radius: 5px;
}

.info-alert-wrapper--form-mode {
	max-width: 400px;
}

.info-icon {
	margin-inline-end: 8px;
}

.link {
	text-decoration: underline;
}
</style>
